import { http } from 'vue'

export default {
  createChat (context, params = {}) {
    return http.post('rent_pre_registration_chats', params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rent_pre_registration_chat/actions.js